var exports = {
  "wI": "WhatsNewModal.module__whatsNewRoot___X0V5NG",
  "UT": "WhatsNewModal.module__contentShell___X0V5NG",
  "N4": "WhatsNewModal.module__coverImage___X0V5NG",
  "yp": "WhatsNewModal.module__contentBody___X0V5NG",
  "hZ": "WhatsNewModal.module__dateLine___X0V5NG",
  "eM": "WhatsNewModal.module__markdownBody___X0V5NG",
  "qr": "WhatsNewModal.module__footer___X0V5NG",
  "GZ": "WhatsNewModal.module__blueskyLink___X0V5NG",
  "$Y": "WhatsNewModal.module__blueskyIcon___X0V5NG",
  "r": "WhatsNewModal.module__dismissButton___X0V5NG",
  "T7": "WhatsNewModal.module__scrollHint___X0V5NG",
  "LL": "WhatsNewModal.module__scrollHintVisible___X0V5NG",
  "HF": "WhatsNewModal.module__scrollHintCircle___X0V5NG",
  "ki": "WhatsNewModal.module__scrollHintPulse___X0V5NG",
};

module.exports = exports;
